import React, {  useMemo } from "react";
import { BsHeart, BsHeartFill } from "react-icons/bs";
import { PiChatTeardropThin } from "react-icons/pi";
import { CommunityFeedType, FeedLikeType } from "../../types";
import { useDispatch, useSelector } from "react-redux";
import {
  ApolloQueryResult,
  OperationVariables,
  useMutation,
} from "@apollo/client";
import { CREATE_FEED_LIKES, DELETE_FEED_LIKES } from "../../apollo/operations";
import { ActivityReader } from "..";
import { setLikedPost } from "../../redux/slices/communityFeedSlice";

type ActivityProps = {
  textArea: React.RefObject<HTMLTextAreaElement | null>;
  communityFeed: CommunityFeedType | undefined;
  openModal?: boolean;
  onOpen?: () => void;
  inputArea: React.RefObject<HTMLInputElement | null>;
  refetch: (
    variables?: Partial<OperationVariables> | undefined
  ) => Promise<ApolloQueryResult<any>>;
  feedLikes: FeedLikeType | undefined;
  loading: boolean;
  setLoadings: React.Dispatch<React.SetStateAction<boolean>>;
  setModalRemove: React.Dispatch<React.SetStateAction<boolean>>;
  refetchAllFeeds: (() => void) | undefined;
  // userFeed?: UserFeedsType;
};
const Activity: React.FC<ActivityProps> = ({
  textArea,
  communityFeed,
  openModal,
  onOpen,
  inputArea,
  feedLikes,
  loading,
  refetch,
  setLoadings,
  setModalRemove,
  refetchAllFeeds,
}) => {
  const user = useSelector((state: any) => state.user.userDetails);
  const dispatch = useDispatch();

  // const [loadings, setLoadings] = React.useState(false);
  const [showDetailedLikes, setShowDetailedLikes] = React.useState(false);
  const [deleteLikeLoading, setDeleteLikeLoading] = React.useState(false);
  const [createLikeLoading, setCreateLikeLoading] = React.useState(false);

  const specificUserLike = communityFeed?.feedLikes?.find(
    (a) => a.likedBy.id === user.id
  );

  const Liker =
  communityFeed &&
  communityFeed?.feedLikes?.find((a) => {
      return a.likedBy.id === specificUserLike?.likedBy.id;
    });

  // console.log(Liker?.id, "Liker");
  const [deleteFeedLikes] = useMutation(
    DELETE_FEED_LIKES,
    {
      onCompleted: (data) => {
        // console.log(data);
        // console.log("like removed");
        refetch();
      },
      onError: (err) => {
        const errMsg = err.graphQLErrors[0].extensions?.originalError;
        console.log(errMsg);
        console.log(err);
      },
    }
  );

  const handleDelete = async (
    e: React.MouseEvent<HTMLButtonElement>
  ) => {
    e.preventDefault();
    setLoadings(true);
    setModalRemove(true);
    setDeleteLikeLoading(true);
    setShowDetailedLikes(false);
    if (Liker?.likedBy.id && Liker.id) {
      await deleteFeedLikes({
        variables: {
          where: {
            id: Liker?.id,
          },
        },
      })
        .then(() => {
          if(refetchAllFeeds) refetchAllFeeds();
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };

  const [createFeedLikes] = useMutation(
    CREATE_FEED_LIKES,
    {
      onCompleted: (data) => {
        // console.log(data);
        refetch();
      },
      onError: (err) => {
        console.log(err);
        const errorMsg = err?.graphQLErrors[0].extensions?.originalError;
        console.log(errorMsg);
      },
    }
  );

  const handleLikes = async (
    e: React.MouseEvent<HTMLButtonElement>
  ) => {
    e.preventDefault();
    setLoadings(true);
    setCreateLikeLoading(true);
    setShowDetailedLikes(false);
    if (user.id)
      await createFeedLikes({
        variables: {
          data: {
            communityFeed: {
              id: communityFeed?.id,
            },
            likedBy: {
              id: user?.id,
            },
          },
        },
      }).then(() => {
        if(refetchAllFeeds) refetchAllFeeds();
      });
  };

  // Function to handle button click.
  //  This button links the chat Icon to the text area input.
  const handleTextAreaBt = () => {
    const isLargeScreen = window.innerWidth >= 976; // You may adjust this value based on Tailwind's lg breakpoint

    if (textArea && textArea.current && isLargeScreen) {
      textArea.current.focus(); // Focus on the textarea
      // console.log('Textarea clicked');
    } else if (inputArea && inputArea.current) {
      inputArea.current.focus();
      // console.log('Input clicked');
    }
  };
  useMemo(() => {
    if (!Liker?.id) {
      setDeleteLikeLoading(false);
    }
    if (Liker?.id) {
      setCreateLikeLoading(false);
    }
  }, [Liker?.id]);

  const ReaderActivity = !openModal && (
    <ActivityReader
      communityFeed={communityFeed}
      feedLikes={feedLikes}
      onOpen={onOpen}
      deleteLikeLoading={deleteLikeLoading}
      createLikeLoading={createLikeLoading}
      setShowDetailedLikes={setShowDetailedLikes}
      showDetailedLikes={showDetailedLikes}
    />
  );

  return (
    <>
      {openModal === false && ReaderActivity}
      <div className="w-full px-4 relative">
        <div className="flex justify-between border-t lg:h-10 pt-3">
          <div className="flex gap-4">
            {communityFeed?.id && (
              <>
                {createLikeLoading || deleteLikeLoading ? (
                  createLikeLoading ? (
                    <BsHeartFill size={22} color="red" className="mt-1" />
                  ) : (
                    deleteLikeLoading && <BsHeart size={22} className="mt-1" />
                  )
                ) : Liker?.likedBy.id ? (
                  <button onClick={handleDelete}>
                    <BsHeartFill
                      size={22}
                      color="red"
                      className="cursor-pointer mt-1"
                    />
                  </button>
                ) : (
                  <button onClick={handleLikes}>
                    <BsHeart size={22} className="cursor-pointer mt-1" />
                  </button>
                )}
              </>
            )}

            <PiChatTeardropThin
              size={27}
              onClick={() => {
                if (openModal) {
                  handleTextAreaBt();
                } else {
                  if (onOpen) onOpen();
                  dispatch(setLikedPost(feedLikes));
                  if (refetchAllFeeds) refetchAllFeeds();
                }
              }}
              // onClick={openModal ? handleTextAreaBt : onOpen}
              className="mt-px cursor-pointer"
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default Activity;
